export const API_URL: string = "";
export const TOKEN_NAME: string = "CryptoLoots";
export const COMPANY_NAME: string = "CryptoLoots";



// WEBPACK FOOTER //
// ./src/utils/constants.ts